import { io } from "socket.io-client";

const hostname = window.location.hostname;

let SOCKET_URL = "";
let SOCKET_PATH = "";

if (hostname === "localhost" || hostname === "127.0.0.1") {
  SOCKET_URL = "http://localhost:3838";
  SOCKET_PATH = "/socket.io/";
} else if (hostname.includes("dev")) {
  SOCKET_URL = "https://dev-backend.flownect.com";
  SOCKET_PATH = "/vr-assistant/socket.io/";
} else {
  SOCKET_URL = "https://backend.flownect.com";
  SOCKET_PATH = "/vr-assistant/socket.io/";
}


export const socket = io(`${SOCKET_URL}/twilio`, {
  path: SOCKET_PATH,
  transports: ["websocket", "polling"],
  withCredentials: true,
});

socket.on("connect", () => {
  console.log("[VR SOCKET] Connected:", socket.id);
});

socket.on("disconnect", (reason) => {
  console.log("[VR SOCKET] Disconnected:", reason);
});

socket.on("connect_error", (error) => {
  console.log("[VR SOCKET] Connection error:", error.message);
});